<template>
    <div class="left_panel creat_team_page">
        <form
            method="post"
            @submit.prevent="addTeam()"
            data-vv-scope="addteamform"
        >
            <div class="panel_head_wrap">
                <div class="panel_heading"><h2>Create Team</h2></div>
                <!-- <div><h2>email verify</h2></div> -->
            </div>

            <div class="panel_main_box manage_team_box bg_primary_light_white">
                <div class="card-body first_card">
                    <h3 class="text_primary_blue font_size_18 mb_40 mt_20">
                        Details
                    </h3>
                    <div class="row details_box">
                        <div class="col-md-12 col-lg-4">
                            <label class="label-control2 font_size_14 ml-8"
                                >Team/Group Name</label
                            >
                            <fieldset class="form-group mb_40 mt-0 ml-0">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter Team/Group Name"
                                    v-validate="'required'"
                                    class="form-control mb-0 mt-0"
                                    v-model="team_data.name"
                                    aria-required="true"
                                    aria-invalid="true"
                                />
                                <small
                                    class="form-text text-error text-left"
                                    v-show="errors.has('addteamform.name')"
                                >
                                    {{ errors.first("addteamform.name") }}
                                </small>
                            </fieldset>
                        </div>
                        <div class="col-md-12 col-lg-4 d-md-flex mb_40">
                            <div class="">
                                <label class="label-control2 font_size_14 ml-8"
                                    >Team Logo</label
                                >
                                <fieldset
                                    class="form-group custom-input-label1 mb-0 mt-0 ml-0 new-feild-section"
                                >
                                    <input
                                        type="text"
                                        placeholder="Select"
                                        class="form-control mb-0 mt-0 sl_place"
                                    />
                                    <button
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload_upload"
                                        data-toggle="modal"
                                        data-target="#crop_modal"
                                        type="button"
                                    >
                                        Browse
                                    </button>
                                </fieldset>
                            </div>
                            <div
                                class="brand_logo creat_team_logo pt-1 pb-0 pl-0 pr-0 d-flex"
                            >
                                <div class="form-check brand_logo_img">
                                    <img
                                        :src="
                                            team_data.logo_file
                                                ? team_data.logo_file
                                                : '/maincss/images/us_tiger_img.png'
                                        "
                                        alt="Logo"
                                    />
                                </div>
                                <div>
                                    <a
                                        @click="removeLogoFile"
                                        href="javascript:void(0)"
                                        ><img
                                            class="bin_icon"
                                            alt=""
                                            src="/maincss/images/icons/delete_dark.svg"
                                    /></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-4">
                            <label class="label-control2 font_size_14 ml-8"
                                >Coach/Team Lead</label
                            >
                            <v-select
                                label="full_name"
                                :reduce="(name) => name.id"
                                :options="coaches_list"
                                name="team_lead_id"
                                v-model="team_data.team_lead_id"
                                :placeholder="'Select Coach/Team Lead'"
                                v-validate="'required'"
                            >
                            </v-select>
                            <small
                                class="form-text text-error text-left"
                                v-show="errors.has('addteamform.team_lead_id')"
                            >
                                {{ errors.first("addteamform.team_lead_id") }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="preloader" v-show="isLoader">
                    <div class="preloader-body">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <polygon
                                class="rect"
                                points="0 0 0 40 40 40 40 0"
                            ></polygon>
                        </svg>
                    </div>
                </div>
            </div>

            <div
                class="box_checkbox create_tem_checkbox bg_primary_light_white px_36 py_20 mt_24 mb_30"
            >
                <div class="row crea_team_checkbox">
                    <div
                        v-for="(coach, index) in coaches_list"
                        :key="index"
                        class="col-md-12 d-flex align-items-center mb_8"
                    >
                        <div class="form-check pl-0 py_6 d-flex w_70">
                            <label
                                class="checkbox_custom mb-0 font_size_16 text_primary_blue pl_40"
                            >
                                {{ coach.full_name }}
                                <input
                                    type="checkbox"
                                    v-model="team_data.players"
                                    :value="coach.id" /><span
                                    class="checkmark"
                                ></span
                            ></label>
                        </div>
                        <div class="form-check pl-0 py_6 d-flex w_30">
                            <span class="pr_6">
                                <img
                                    alt=""
                                    src="/maincss/images/icons/placeholder.svg"
                                />
                            </span>
                            <span class="pt_2" v-if="coach.Profile">{{
                                coach.Profile.city
                            }}</span>
                        </div>
                    </div>
                    <input type="hidden" v-model="team_data.id" />
                </div>
            </div>
            <div
                class="buttons create_team_btns edit_profile_btn d-flex justify-content-end"
            >
                <router-link :to="{ name: 'ManageTeam' }">
                    <a
                        href="javascript:void(0)"
                        class="btn btn_outline_primary border_primary_blue text_primary_blue font_size_15 pt_20 pr_50 pb_20 pl_50"
                    >
                        Cancel
                    </a>
                </router-link>
                <button
                    type="submit"
                    class="btn btn_orange bg_primary_orange text_white ml_20 font_size_15 pt_20 pr_50 pb_20 pl_50"
                    v-if="buttonUpdate == true"
                >
                    Update Team
                </button>
                <button
                    type="submit"
                    class="btn btn_orange bg_primary_orange text_white ml_20 font_size_15 pt_20 pr_50 pb_20 pl_50"
                    v-else
                >
                    Create Team
                </button>
            </div>
        </form>
        <!--crop popup-->

        <div
            class="modal login-form-popup fade h-auto"
            id="crop_modal"
            tabindex="-1"
            aria-labelledby="login"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div class="login-form">
                            <h3>Upload and Crop</h3>
                            <!--crop tool-->

                            <div class="upload_crop_design_studio">
                                <div class="team_logo_upload_box">
                                    <form action="">
                                        <div class="team_logo_input_text_box">
                                            <label
                                                for="formFile"
                                                class="form-label"
                                            >
                                                <span class="choose_file_span"
                                                    >Choose File</span
                                                >
                                                <span
                                                    class="no_file_chosen_span"
                                                    >No file chosen</span
                                                ></label
                                            >
                                        </div>
                                        <input
                                            type="file"
                                            class="form-control"
                                            @change="croppie"
                                        />
                                    </form>
                                </div>

                                <small
                                    class="form-text text-error"
                                    v-if="crop_image_validation == 0"
                                    >Incorrect image format.Please upload the
                                    Png, Jpg, Jpeg image formats</small
                                >
                                <vue-croppie
                                    ref="croppieRef"
                                    :enableOrientation="true"
                                    :enableResize="false"
                                    :setZoom="0"
                                    :boundary="{ width: 300, height: 300 }"
                                    :viewport="{
                                        width: 200,
                                        height: 200,
                                        type: 'square'
                                    }"
                                >
                                </vue-croppie>
                            </div>

                            <!-- Rotate angle is Number -->
                            <div class="crp_bottom_btn creat-team-crp">
                                <button
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                    type="button"
                                    @click="rotate(-90)"
                                >
                                    Rotate Left
                                </button>
                                <button
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                    type="button"
                                    @click="rotate(90)"
                                >
                                    Rotate Right
                                </button>
                                <button
                                    style="
                                        background-color: #f2790c !important;
                                        color: #fff !important;
                                        border: 1px solid #f2790c !important;
                                    "
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                    type="button"
                                    @click="crop"
                                >
                                    Crop
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "ManageTeam",
    components: {},
    data() {
        return {
            buttonUpdate: false,
            team_data: {
                is_image_uploaded: false,
                logo_file: null,
                players: []
            },
            coaches_list: [],
            isLoader: false,
            croppieImage: "",
            crop_image_validation: 1
        };
    },
    mounted() {
        //load default image in croptool
        this.$refs.croppieRef.bind({
            url: "/maincss/design-studio/img/design-st-upload.jpg",
            zoom: 0
        });
        /* eslint-disable */
        $(".cr-slider").prop("disabled", true);
        if (this.$route.params.id != undefined) {
            this.buttonUpdate = true;
            this.isLoader = false;
            this.getSingleTeam(this.$route.params.id);
        }
        $(document).on("click", ".browse", function () {
            var file = $(this).parents().find(".file");
            file.trigger("click");
        });
        /* eslint-enable */
        this.getCoaches();
    },
    methods: {
        // EVENT USAGE
        cropViaEvent() {
            /* eslint-disable */
            this.$refs.croppieRef.result(options);
            /* eslint-enable */
        },
        result(output) {
            this.cropped = output;
        },
        update(val) {
            console.log(val);
        },
        rotate(rotationAngle) {
            // Rotates the image
            this.$refs.croppieRef.rotate(rotationAngle);
        },
        croppie(e) {
            /* eslint-disable */
            $(".cr-slider").prop("disabled", false);
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.image_size = files[0].size / (1024 * 1024);
            if (
                files[0]["type"] != "image/jpeg" &&
                files[0]["type"] != "image/png" &&
                files[0]["type"] != "image/jpg"
            ) {
                this.crop_image_validation = 0;
                console.log(
                    "Incorrect image format.Please upload the Png, Jpg, Jpeg image formats"
                );
                $("#crop_bdr").val("");
                this.$refs.croppieRef.refresh();

                //load default image in croptool
                this.$refs.croppieRef.bind({
                    url: "/maincss/design-studio/img/design-st-upload.jpg",
                    zoom: 0
                });
            } else {
                this.crop_image_validation = 1;
                var reader = new FileReader();

                reader.onload = (e) => {
                    //  this.croppieImage=e.target.result;
                    this.$refs.croppieRef.bind({
                        url: e.target.result,
                        zoom: 0
                    });
                    //show image
                };
            }
            /* eslint-enable */
            reader.readAsDataURL(files[0]);
        },
        crop() {
            this.image_width = 200;
            this.image_height = 200;
            let options = {
                type: "base64",
                size: { width: this.image_width, height: this.image_height },
                format: "jpeg"
            };
            console.log(options);
            this.$refs.croppieRef.result(options, (output) => {
                this.cropped = this.croppieImage = output;
                this.team_data.logo_file = this.croppieImage;
                this.team_data.is_image_uploaded = true;
            });
            /* eslint-disable */
            $("#crop_modal").modal("hide");
            $("#crop_bdr").val("");
            /* eslint-enable */
            this.$refs.croppieRef.refresh();

            //load default image in croptool
            this.$refs.croppieRef.bind({
                url: "/maincss/design-studio/img/design-st-upload.jpg",
                zoom: 0
            });
        },

        //croppie function end
        addTeam() {
            var _this = this;
            _this.$validator.validateAll("addteamform").then((isValid) => {
                if (isValid) {
                    _this.isLoader = true;
                    new Promise((resolve) => {
                        if (this.$route.params.id != undefined) {
                            ApiService.put("/teams", _this.team_data)
                                .then(({ data }) => {
                                    resolve(data);
                                    _this.isLoader = false;
                                    _this.$toast.success(
                                        "Team updated successfully",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                    _this.$router.push({ name: "ManageTeam" });
                                })
                                .catch(({ response }) => {
                                    /* eslint-disable */
                                    context.commit(SET_ERROR, response.data.errors);
                                    /* eslint-enable */
                                });
                        } else {
                            ApiService.post("/teams", _this.team_data)
                                .then(() => {
                                    _this.isLoader = false;
                                    _this.$toast.success(
                                        "Team added successfully",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                    _this.$router.push({ name: "ManageTeam" });
                                })
                                .catch(({ response }) => {
                                    /* eslint-disable */
                                    context.commit(SET_ERROR, response.data.errors);
                                    /* eslint-enable */
                                });
                        }
                    });
                }
            });
        },
        getCoaches() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/players")
                    .then(({ data }) => {
                        _this.coaches_list = data.players;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                    });
            });
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
        },
        createImage(file) {
            var reader = new FileReader();
            var vm = this;

            reader.onload = (e) => {
                vm.team_data.logo_file = e.target.result;
                vm.team_data.is_image_uploaded = true;
            };
            reader.readAsDataURL(file);
        },
        removeLogoFile() {
            this.team_data.logo_file = null;
        },

        getSingleTeam(id) {
            var _this = this;
            new Promise(() => {
                ApiService.get("/teams/" + id)
                    .then(({ data }) => {
                        _this.isLoader = false;
                        _this.team_data = {
                            id: data.team.id,
                            name: data.team.name,
                            logo_file: data.team.logo_file,
                            team_lead_id: data.team.team_lead_id,
                            players: data.team.player.map(
                                (element) => element.id
                            )
                        };
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        }
    }
};
</script>
